import { render, staticRenderFns } from "./MobileAboutUsComponent.vue?vue&type=template&id=e834ad8e&lang=pug&"
import script from "./MobileAboutUsComponent.vue?vue&type=script&lang=js&"
export * from "./MobileAboutUsComponent.vue?vue&type=script&lang=js&"
import style0 from "./MobileAboutUsComponent.vue?vue&type=style&index=0&id=e834ad8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports